<section class="favorite-tracks-screen">

  <!-- Unselected, Favorite Track -->
  <div class="unselected-favorite-row tw-text-center tw-mb-[38px] tw-pt-[15px]">
    <div class="unselected tw-w-[50%] tw-float-left">
      <p (click)="unSelectedTrackTab($event)"
        class="active tw-w-[150px] tw-text-[16px] tw-text-[#BBBBBB]"
        data-cy="unselected-tracks"
      >
        Unselected Tracks
      </p>
      <!-- <div class="tab active"></div> -->
    </div>
    <div class="favorite tw-w-[50%] tw-float-left">
      <p (click)="favoriteTrackTab($event)"
        class="tw-w-[150px] tw-text-[16px] tw-text-[#BBBBBB] tw-ml-auto"
        data-cy="favorite-track-list"
      >
        Favorite Track List
      </p>
      <!-- <div class="tab"></div> -->
    </div>
  </div>

  <div *ngIf="unSelectedTracks" class="tw-mb-[40px]">
    <!-- Track Name, Add, Refresh -->
    <div class="tracks-name-add-refresh tw-mb-[32px]">
      <input
        (input)="onSearch($event, false)"
        type="text"
        placeholder="Tracks Name"
        class="
          tw-w-[218px]
          tw-h-[38px]
          tw-float-left
          tw-bg-[#E8E8E8]
          tw-text-[19px]
          tw-text-[#9A9A9A]
          tw-rounded-[6px]
          tw-mr-[10px]
          tw-py-[8px]
          tw-px-[9px]
        "
        data-cy="track-name"
      >
      <button
        (click)="addEvent()"
        class="
          tw-float-left
          tw-bg-[#2F80EC]
          tw-text-[#FFFFFF]
          tw-text-[10px]
          tw-rounded-[7px]
          tw-py-[7px]
          tw-px-[20px]
        "
        data-cy="fav-add-btn"
      >
        <span>+ </span>
        <span class="tw-text-[16px] tw-ml-[2px]">Add</span>
      </button>
    <img
      (click)="refreshSelectedEvents()"
      src="/assets/images/account_settings/reloading_icon_light.png"
      class="
        l-mode tw-relative
        tw-top-[3px]
        tw-float-left
        tw-w-[33px]
        tw-inline
        tw-ml-[10px]
      "
      alt="reloading icon"
    >
    <img
      (click)="refreshSelectedEvents()"
      src="/assets/images/account_settings/reloading_icon_dark.png"
      class="
        d-mode
        tw-relative
        tw-top-[3px]
        tw-float-left
        tw-w-[33px]
        tw-inline
        tw-ml-[10px]
      "
      alt="reloading icon"
      data-cy="reset-btn"
    >
    </div>

    <!-- Event Types -->
    <!-- *ngIf="showEvent(item.EventId, false)" -->
    <div class="tw-h-[322px] tw-overflow-y-auto">
      <ng-container
        *ngFor="let item of untrackedEvents; index as i"
      >
        <div
          (click)="selectEvent($event, item.EventId, i)"
          class="event-row tw-flex tw-items-center"
        >
          <i
            id="toggle-{{i}}"
            class="
              selector
              tw-block
              tw-w-[15px]
              tw-h-[15px]
              tw-bg-[#E8E8E8]
              tw-rounded-[10px]
              tw-border
              tw-border-[#E0E0E0]
              tw-mr-[9px]
            "
          ></i>
          <p
            class="
              tw-w-[90%]
              tw-capitalize
              tw-font-bold
              tw-text-[16px]
              tw-text-[#0F2950]
              tw-border-b
              tw-border-[#868484]
              tw-py-[2px]
              tw-pl-[7px]
            "
          >
            {{ item.EventName }}
          </p>
        </div>
      </ng-container>
    </div>
  </div>

  <div *ngIf="favoriteTracks" class="tw-mb-[40px]">
    <!-- Track Name, Clear All -->
    <div class="tracks-name-clear-all tw-mb-[32px]">
      <input
        (input)="onSearch($event, true)"
        type="text"
        placeholder="Tracks Name"
        class="
          tw-w-[70%]
          tw-h-[38px]
          tw-float-left
          tw-bg-[#E8E8E8]
          tw-text-[19px]
          tw-text-[#9A9A9A]
          tw-rounded-[6px]
          tw-mr-[10px]
          tw-py-[8px]
          tw-px-[9px]
        "
      >
      <button
        (click)="clearFavoriteEvents()"
        class="
          tw-float-left
          tw-bg-[#2F80EC]
          tw-text-[#FFFFFF]
          tw-text-[10px]
          tw-rounded-[7px]
          tw-py-[7px]
          tw-px-[20px]
        "
      >
        <span class="tw-text-[16px]">Clear All</span>
      </button>
    </div>

    <!-- Event Types -->
    <!-- *ngIf="showEvent(item.EventId, true)" -->
    <div class="tw-h-[322px] tw-overflow-y-auto">
      <ng-container *ngFor="let item of favoriteEvents; index as i">
        <div
          (click)="selectEvent($event, item.EventId, i)"
          class="event-row tw-flex tw-items-center"
        >
          <i
            id="toggle-{{i}}"
            class="
              selector
              tw-block
              tw-w-[15px]
              tw-h-[15px]
              tw-bg-[#E8E8E8]
              tw-rounded-[10px]
              tw-border
              tw-border-[#E0E0E0]
              tw-mr-[9px]
            "
          ></i>
          <p
            class="
              tw-w-[90%]
              tw-capitalize
              tw-font-bold
              tw-text-[16px]
              tw-text-[#0F2950]
              tw-border-b
              tw-border-[#868484]
              tw-py-[2px]
              tw-pl-[7px]
            "
          >
            {{ item.EventName }}
            <img
              (click)="removeEvent($event, item.EventId)"
              src="/assets/images/account_settings/trash_icon_light.svg"
              class="l-mode tw-z-50 tw-relative tw-top-[4px] tw-float-right"
              alt="trash icon"
            >
            <img
              (click)="removeEvent($event, item.EventId)"
              src="/assets/images/account_settings/trash_icon_dark.svg"
              class="d-mode tw-z-50 tw-relative tw-top-[4px] tw-float-right"
              alt="trash icon"
            >
          </p>
        </div>
      </ng-container>
    </div>
  </div>

</section>
